import { Component } from "react";
import GetIcon from "./GetIcon.tsx";
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { MdClose } from "react-icons/md";
import RoundButton from "./RoundButton.jsx";
import { INVENTARIO_ABERTO, INVENTARIO_ENCERRANDO_1, INVENTARIO_ENCERRANDO_2 } from "../util/contants";

export default class CloseInventDialog extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Dialog open={true} sx={{ zIndex: 99999 }}>
                <DialogTitle color="primary" fontSize={12}><b>FECHAMENTO DE INVENTÁRIO</b></DialogTitle>
                <IconButton onClick={e => this.props.onClose()} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <MdClose size={18} />
                </IconButton>
                <DialogContent>
                    <Stack width={350}>
                        {this.props.step === 0 && <Typography variant="caption" mb={2}>Você tem certeza que desejar fechar o inventário? Esse procedimento é irreversível.</Typography>}
                        {this.props.step > 0 &&
                            <Stack direction="row">
                                <CircularProgress size={17} />
                                <Typography ml={1} variant="caption" mb={2}>
                                    {this.props.step === INVENTARIO_ABERTO && 'Consolidando contagens...'}
                                    {this.props.step === INVENTARIO_ENCERRANDO_1 && 'Ajustando os produtos...'}
                                    {this.props.step === INVENTARIO_ENCERRANDO_2 && 'Encerrando inventário...'}
                                </Typography>
                            </Stack>
                        }
                    </Stack>
                </DialogContent>
                <DialogActions>
                    {this.props.step === 0 && <>
                        <RoundButton onClick={() => this.props.onConfirm()}>Sim</RoundButton>
                        <RoundButton onClick={() => this.props.onClose()}>Cancelar</RoundButton>
                    </>}
                </DialogActions>
            </Dialog>
        );
    }
}
